export const BARCODE_MIN_LENGTH = 8
export const BARCODE_MAX_LENGTH = 14

export const BARCODE_DIGITS_ONLY_MESSAGE =
  'Штрихкод должен содержать только цифры'
export const BARCODE_LENGTH_MESSAGE = `Длина штрихкода должна быть от ${BARCODE_MIN_LENGTH} до ${BARCODE_MAX_LENGTH} цифр`

export const sanitizeBarcode = (value: string) => value.replace(/\s+/g, '')

export const getBarcodeError = (value: string) => {
  const barcode = sanitizeBarcode(value)
  if (barcode === '') return null
  if (!/^\d+$/.test(barcode)) return BARCODE_DIGITS_ONLY_MESSAGE
  if (
    barcode.length < BARCODE_MIN_LENGTH ||
    barcode.length > BARCODE_MAX_LENGTH
  )
    return BARCODE_LENGTH_MESSAGE
  return null
}
